export default __webpack_public_path__ + "static/media/green_medium.682d89a8.png";